import { FETCHING_LANGUAGES, FETCH_LANGUAGES } from './preferredLanguagesContainerActions'

export default function (state = { loading: false, languages: [] }, action) {
  switch (action.type) {
    case FETCH_LANGUAGES:
      return { 
        loading: false, 
        languages: action.payload.map(item => ({ ...item }))
      }
    case FETCHING_LANGUAGES:
      return { loading: true, languages: [] }
  }
  return state
}
